/**
 * author: liuhaojun@tuhu.cn
 * date: 2018/09/20
 * describe:
 *  指令接受一个对象或number值或false, 对象包括num, productId, orderId三个属性,num:客服分组, productId:商品Id, orderId:订单Id 如果值为false则不跳转
 *  num表示客服分组对应的客服ID请参考下面newCustomerCareDictory对象
 *  点击使用了该指令的元素会自动跳转到相应客服页面
 * demo:
    <div v-new-customer-care="0">点我</div>
    <div v-new-customer-care="{num: 0, productId: 'ss'}">点我</div>
    <div v-new-customer-care="{num: 0, orderId: 'ss'}">点我</div>
    <div v-new-customer-care="{num: 0}">点我</div>
 */
const newCustomerCareDictory = {
  0: {  // 轮胎和默认 未传值或者传值类型不是number的情况下默认为0
    app: 'tuhu_app_lt',
    h5: 'tuhu_h5_lt'
  },
  1: {  // 保养
    app: 'tuhu_app_by',
    h5: 'tuhu_h5_by'
  },
  2: {  // 汽车美容
    app: 'tuhu_app_mr',
    h5: 'tuhu_h5_mr'
  },
  3: {  // 车品
    app: 'tuhu_app_cp',
    h5: 'tuhu_h5_cp'
  },
  4: {  // 汽车改装
    app: 'tuhu_app_gz',
    h5: 'tuhu_h5_gz'
  },
  5: {  // 蓄电池
    app: 'tuhu_app_xdc',
    h5: 'tuhu_h5_xdc'
  },
  6: {  // 轮毂
    app: 'tuhu_app_lg',
    h5: 'tuhu_h5_lg'
  },
  7: {  // 加油充值
    app: 'tuhu_app_jycz',
    h5: 'tuhu_h5_jycz'
  },
  8: {  // 违章代缴
    app: 'tuhu_app_wzdj',
    h5: 'tuhu_h5_wzdj'
  },
  9: {  // 钣金喷漆
    app: 'tuhu_app_bjpq',
    h5: 'tuhu_h5_bjpq'
  },
  10: { // 车险
    app: 'tuhu_app_cx',
    h5: 'tuhu_h5_cx'
  },
  11: { // 镭射眼
    app: 'tuhu_app_lsy',
    h5: 'tuhu_h5_lsy'
  },
  12: { // 售后
    app: 'tuhu_app_shouhou',
    h5: 'tuhu_h5_shouhou'
  }
}

class NewCustomerCare {
  constructor(type) {
    let num
    let productId
    let orderId

    if (typeof type === 'object') {
      num = type.num
      productId = type.productId
      orderId = type.orderId
    } else {
      num = type
    }

    if (typeof (+num) !== 'number') {
      num = 0
    }

    return this.init(num, productId, orderId)
  }

  async init(num, productId, orderId) {
    return new Promise(async (resolve, reject) => {
      let userinfo = await tuhu.getUserInfo()
      let uname = userinfo.name || ''
      let uid = userinfo.userid || ''
      let receptionId = this.getDictory(num)
      let pcid = this.getGuid()
      let sdkkey = '4f1b5898f498a048ab2686fb68e6afa7'
      let chatInfoType = this.getChatInfoType(productId, orderId)
      let chatInfoId = orderId || productId || ''
      let type = {
        skillGroupNo: receptionId || 'tuhu_h5_lt', // 接待组ID
        customerName: receptionId || 'tuhu_h5_lt', // 接待组ID 老版本兼容效果同skillGroupNo
        containerId: '#app',  // 必填
        sdkkey: sdkkey, // 必填
        pcid: pcid || '',
        uid: uid || '',
        uname: uname || '',
        isvip: '',
        userlevel: '',
        isShow: false,
        chatInfoType: chatInfoType,
        chatInfoId: chatInfoId
      }
      resolve(type)
    })
  }

  getChatInfoType(productId, orderId) {
    if (orderId) {
      return 'order'
    } else if (productId) {
      return 'product'
    } else {
      return ''
    }
  }

  getGuid() {
    let item = localStorage.getItem('guid')
    if (!item) {
      localStorage.setItem('guid', tuhu.util.uuid())
      return localStorage.getItem('guid')
    }
    return item
  }

  getDictory(num) {
    num = Number(num)

    if (typeof num === 'number') { // 对传值进行校验
      num = Math.floor(num)

      if (num < 0 || isNaN(num)) {
        num = 0
      }
    } else {
      num = 0
    }

    if (tuhu.device.isApp) {
      return newCustomerCareDictory[num].app
    } else {
      return newCustomerCareDictory[num].h5
    }
  }
}

Vue.directive('new-customer-care', {
  inserted: (el, arg) => {
    $(el).on('click', async () => {
      if (arg.value === false) return
      new NewCustomerCare(arg.value).then(type => {
        localStorage.setItem('wapsdk', JSON.stringify(type))  // localStorage的名字为wapsdk，勿改，因为涉及到第三方拿数据
        tuhu.navigateTo({
          url: '/pages/_newcustomer/index',
          query: {
            type: type
          }
        })
      })
    })
  }
})



// WEBPACK FOOTER //
// ./lib/directives/newCustomerCare.js